import { Component } from "@angular/core";
import { TaskBaseMagicComponent, magicProviders } from "@magic-xpa/angular";
import { MagicModalInterface } from "@magic-xpa/angular";
import { FormControl, FormGroup } from "@angular/forms";
import { variable } from "@angular/compiler/src/output/output_ast";
@Component({
  selector: "mga-FileTransferSample",
  providers: [...magicProviders],
  styleUrls: ['./FileTransferSample.component.css'],
  templateUrl: "./FileTransferSample.component.html"
})
export class FileTransferSample extends TaskBaseMagicComponent
  implements MagicModalInterface {
  private static readonly formName: string = "FileTransferSample";
  private static readonly showTitleBar: boolean = false;
  private static readonly x: number = 0;
  private static readonly y: number = 0;
  private static readonly width: string = "260px";
  private static readonly height: string = "65px";
  private static readonly isCenteredToWindow: boolean = true;
  private static readonly shouldCloseOnBackgroundClick = false;
  X() {
    return FileTransferSample.x;
  }
  Y() {
    return FileTransferSample.y;
  }
  Width(): string {
    return FileTransferSample.width;
  }
  Height(): string {
    return FileTransferSample.height;
  }
  IsCenteredToWindow() {
    return FileTransferSample.isCenteredToWindow;
  }
  FormName() {
    return FileTransferSample.formName;
  }
  ShowTitleBar() {
    return FileTransferSample.showTitleBar;
  }
  ShouldCloseOnBackgroundClick() {
    return FileTransferSample.shouldCloseOnBackgroundClick;
  }

  ngOnInit() {
    super.ngOnInit();
    let group: FormGroup = this.screenFormGroup;
    (<FormControl>group.controls["Blob64AtServer"]).registerOnChange(
      this.OnChange.bind(this)
    );
  }
  OnChange() {
    if (
      this.mg.getValue("Blob64AtServer") !== undefined &&
      this.mg.getValue("Blob64AtServer") !== null
    ) {
      this.uhgetfile();
      const vbooln = this.mg.setValueToControl("Blob64AtServer", null);
      const vfiln = this.mg.setValueToControl("vfilename", null);
    }
  }

  uhgetfile() {
    const base64 = this.mg.getValue("Blob64AtServer");
    let vpath = this.mg.getValue("vfilename");
    let pname = vpath.split("\\");

    if (base64 !== undefined || base64 !== null) {
      const contentType = base64.split(";")[0];
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (var i = 0; i < byteCharacters.length; i++)
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      const byteArray = new Uint8Array(byteNumbers);
      const binblb = new Blob([byteArray], { type: contentType });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(binblb); // For IE browser
      }

      if (binblb.size !== 0) {
        const downloadLink = document.createElement("a");
        const fileName = this.mg.getValue("vfilename");
        const linkSource = window.URL.createObjectURL(binblb);
        console.log(linkSource);
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        window.URL.revokeObjectURL(linkSource);
      }
    }
  }

  fileText: string | ArrayBuffer;

  fileUpload(event) {
    const reader = new FileReader();
    let size = event.srcElement.files[0].size / 1024 / 1024;
    if (size <= 5.1) {
      reader.readAsDataURL(event.srcElement.files[0]);
      const i = event.srcElement.files[0].type.length;
      const num = 5 + i + 8;
      const me = this;

      reader.onload = function() {
        me.fileText = reader.result;

        //Blob Craetion at client side
        me.mg.setValueToControl("vBlob64FromClient", me.fileText.slice(num));

        //FileName
        me.mg.setValueToControl("vFileNameU", event.srcElement.files[0].name);

        //FileType

        document.getElementById("mgGetFile").click();
      };
    } else {
      alert("Tamanho máximo permitido: 5MB. Tamanho do arquivo selecionado: " + size);
    }
  }
}
